import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, ref } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  FilterSelect,
  HeadingDisplay,
  SpinnerLoader
} from '@warrenbrasil/nebraska-web';
import { BarChart } from '@/modules/common/components/charts/v2/BarChart';
import { SeriesOptionsType } from 'highcharts';
import { MainError } from '@/modules/trade/components/MainError';
import { MainLoading } from '@/modules/trade/components/MainLoading';
import { Money } from '@/modules/common/components/Money';

import {
  getProfitChart,
  PerformanceTypeFilter,
  IProfitChartData
} from '@/modules/wealth/services/portfolio';

interface Props {
  portfolioId: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfitChart',
  props: {
    portfolioId: null
  },
  setup(__props: any) {

const props = __props as {
  portfolioId: string;
}



const periodFilters = ref<PerformanceTypeFilter[]>([
  { label: 'Ano', key: 'annual', active: true }
]);
const periodValue = ref('annual');

const series = ref<SeriesOptionsType[] | null>(null);
const labels = ref<string[]>([]);
const profitValue = ref('');
const maxAxisY = ref<number | undefined>(undefined);

const isLoading = ref(true);
const hasError = ref(false);

const formattedFilters = computed(() => {
  return periodFilters.value?.map(filter => {
    return {
      value: filter.key,
      label: filter.label
    };
  });
});

function getSeries(data: IProfitChartData[]) {
  const formattedValues: number[] = [];

  data.forEach(item => {
    formattedValues.push(item.earnings.value);
  });

  maxAxisY.value = Math.max(...formattedValues);

  return [
    {
      type: 'column',
      name: 'Proventos',
      data: formattedValues,
      color: '#333131'
    }
  ];
}

async function fetchProventsChart() {
  try {
    isLoading.value = true;
    hasError.value = false;

    const axiosX: string[] = [];

    const profit = await getProfitChart(props.portfolioId, periodValue.value);

    profitValue.value = profit.totalEarnings;
    periodFilters.value = profit.periodFilters;

    profit.data.forEach(item => {
      axiosX.push(item.label);
      labels.value = axiosX;
    });

    series.value = getSeries(profit.data) as SeriesOptionsType[];
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onBeforeMount(fetchProventsChart);

return { __sfc: true,props, periodFilters, periodValue, series, labels, profitValue, maxAxisY, isLoading, hasError, formattedFilters, getSeries, fetchProventsChart, NebraskaColors, FilterSelect, HeadingDisplay, SpinnerLoader, BarChart, MainError, MainLoading, Money }
}

})